import store from '../store'
import actions from '../store/actions'

export const getGuarantees = async (contractId) => {
  const guarantees = await store.dispatch(actions.callApi, {
    url: `contracts/${contractId}/guarantees`
  })
  return guarantees.map(item => {
    item.document = item.documents && item.documents.length ? item.documents[item.documents.length - 1] || {} : {}
    return item
  })
}
export const createOrUpdateGuarantee = async (data, contractId) => {
  const guarantee = store.dispatch(actions.callApi, {
    url: data.id ? `contracts/${contractId}/guarantees/${data.id}` : `contracts/${contractId}/guarantees`,
    method: data.id ? 'PUT' : 'POST',
    body: data
  })
  return guarantee
}
export const deleteGuarantee = async (contractId, data) => {
  const guarantee = store.dispatch(actions.callApi, {
    url: `contracts/${contractId}/guarantees/${data.id}`,
    method: 'DELETE'
  })
  return guarantee
}
export const prolongateGuarantee = async (contractId, id, data) => {
  const guarantee = store.dispatch(actions.callApi, {
    url: `contracts/${contractId}/guarantees/${id}/prolongate`,
    method: 'PUT',
    body: data
  })
  return guarantee
}
